import * as React from 'react';
import { showOnBoardingDelete, addSavedOffer } from '@cian/favorites-assign-widget';

import { FavoriteButton } from '../../components/FavoriteButton';
import { useOfferContext } from '../OfferContext';
import { useApplicationContext } from '../../context';
import { EAddFavoritesEntityType, EDeleteFavoritesEntityType, EOfferType } from '../../types';
import { deleteFromFavorites } from '../../services/deleteFromFavorites';
import { addToFavorites } from '../../services/addToFavorites';
import { useDispatch } from 'react-redux';
import type { UnknownAction } from 'redux';

interface IFavoritesContainerProps {
  id: number;
}

export const FavoritesContainer: React.FC<IFavoritesContainerProps> = ({ id }) => {
  const dispatch = useDispatch();
  const context = useApplicationContext();
  const {
    isFavorite: offerInFavorites,
    offerType,
    dealType,
    tracking: { onFavoritesAdd, onFavoritesRemove },
  } = useOfferContext();
  const [isFavorite, setFavorite] = React.useState(offerInFavorites);

  const handleClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();

    // Новостройки или Жилая
    const entityType = offerType === EOfferType.Newobject ? 'newbuilding' : 'offerResidental';

    if (isFavorite) {
      await deleteFromFavorites(context, {
        dealType,
        entityId: id,
        entityType: entityType as EDeleteFavoritesEntityType,
      });

      onFavoritesRemove();

      dispatch(showOnBoardingDelete() as unknown as UnknownAction);
    } else {
      const result = await addToFavorites(context, {
        addToFolder: true,
        dealType,
        entityId: id,
        entityType: entityType as EAddFavoritesEntityType,
      });

      if (!result) {
        return;
      }

      onFavoritesAdd();

      const userHasFolders = Boolean(result.hasFolders);
      const folder = result.folder;
      /* istanbul ignore next */
      const savedInFolders =
        folder && folder.name && folder.id
          ? [
              {
                id: folder.id,
                name: folder.name,
              },
            ]
          : null;

      dispatch(addSavedOffer({ offerIds: [id], savedInFolders, userHasFolders }) as unknown as UnknownAction);
    }

    setFavorite(!isFavorite);
  };

  return <FavoriteButton onClick={handleClick} isActive={isFavorite} />;
};
